module.exports = __webpack_public_path__ + "static/media/light.c495b1be.png";